import { render, staticRenderFns } from "./dj-media-svg.vue?vue&type=template&id=0116c88e&scoped=true&"
import script from "./dj-media-svg.vue?vue&type=script&lang=js&"
export * from "./dj-media-svg.vue?vue&type=script&lang=js&"
import style0 from "./dj-media-svg.vue?vue&type=style&index=0&id=0116c88e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0116c88e",
  null
  
)

export default component.exports